export default "__VITE_ASSET__CcGZXwzw__"